import optimizeExperiments from './optimizeExperiments';

const optimizeExperimentsService = {
    ...optimizeExperiments,
};

export { optimizeExperimentsService };